import angular from 'angular';
import uiRouter from 'angular-ui-router';
import BenefitDaysRequestSwitchComponent from './benefitDaysRequestSwitch.component';

let BenefitDaysRequestSwitchModule = angular.module('BenefitDaysRequestSwitch', [
  uiRouter
])

.component('benefitDaysRequestSwitch', BenefitDaysRequestSwitchComponent)

.name;

export default BenefitDaysRequestSwitchModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestCard/BenefitDaysRequestSwitch/benefitDaysRequestSwitch.js